/**
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 */

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login-page/index')
    },
    {
        path: '/change-password',
        name: 'change-password',
        component: () => import('@/views/login-page/password')
    },
    {
        path: '/',
        name: 'AppIndex',
        component: () => import('@/components/app-main'),
        redirect: () => {
            return {name: 'home'};
        }
    },
    {
        path: '/home',
        component: () => import('@/components/app-main'),
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/home-page/index')
            }
        ]
    },
    {
        path: '/preview/form',
        name: 'preview:form',
        component: () => import('@/views/preview-page/form')
    },
    {
        path: '/notice',
        component: () => import('@/components/app-main'),
        children: [
            {
                path: '/notice',
                name: 'notice',
                component: () => import('@/views/exam-notice/index')
            },
            {
                path: 'detail',
                name: 'notice:detail',
                component: () => import('@/views/exam-notice/detail')
            }
        ]
    },
    {
        path: '/project',
        component: () => import('@/components/app-main'),
        children: [
            {
                path: '/project',
                name: 'project',
                component: () => import('@/views/exam-project/index')
            }
        ]
    },
    {
        path: '/project',
        component: () => import('@/components/project-detail-main'),
        children: [
            {
                path: 'detail',
                name: 'project:detail',
                component: () => import('@/views/exam-project/detail')
            },
            {
                path: '/recruitment/detail',
                name: 'project:recruitment:detail',
                component: () => import('@/views/exam-project/recruitment')
            },
            {
                path: 'apply',
                name: 'project:apply',
                component: () => import('@/views/exam-project/apply-index'),
                children: [
                    {
                        path: 'select',
                        name: 'project:apply:select',
                        component: () => import('@/views/exam-project/select-job')
                    },
                    {
                        path: 'form',
                        name: 'project:apply:form:apply',
                        component: () => import('@/views/exam-project/form-page')
                    },
                    {
                        path: 'result',
                        name: 'project:apply:result',
                        component: () => import('@/views/exam-project/audit-result')
                    },
                    {
                        path: 'written',
                        name: 'project:apply:written',
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'project/pay',
                        name: 'project:apply:pay',
                        props: {
                            title: '缴费',
                            type: 4
                        },
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'written/pay',
                        name: 'project:apply:written:pay',
                        props: {
                            title: '笔试缴费',
                            type: 1
                        },
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'written/print',
                        name: 'project:apply:written:print',
                        props: {
                            title: '打印笔试准考证',
                            printTitle: '打印准考证',
                            type: 1
                        },
                        component: () => import('@/views/exam-project/print-page')
                    },
                    {
                        path: 'written/score',
                        name: 'project:apply:written:score',
                        props: {
                            title: '笔试成绩',
                            type: 1
                        },
                        component: () => import('@/views/exam-project/score-page')
                    },
                    {
                        path: 'interview',
                        name: 'project:apply:interview',
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'interview/pay',
                        name: 'project:apply:interview:pay',
                        props: {
                            title: '面试缴费',
                            type: 2
                        },
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'interview/print',
                        name: 'project:apply:interview:print',
                        props: {
                            title: '打印面试通知单',
                            printTitle: '打印通知单',
                            type: 2
                        },
                        component: () => import('@/views/exam-project/print-page')
                    },
                    {
                        path: 'interview/score',
                        name: 'project:apply:interview:score',
                        props: {
                            title: '面试成绩',
                            type: 2
                        },
                        component: () => import('@/views/exam-project/score-page')
                    },
                    {
                        path: 'physical',
                        name: 'project:apply:physical',
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'physical/pay',
                        name: 'project:apply:physical:pay',
                        props: {
                            title: '体检缴费',
                            type: 3
                        },
                        component: () => import('@/views/exam-project/pay-page')
                    },
                    {
                        path: 'physical/print',
                        name: 'project:apply:physical:print',
                        props: {
                            title: '打印体检通知单',
                            printTitle: '打印通知单',
                            type: 3
                        },
                        component: () => import('@/views/exam-project/print-page')
                    },
                    {
                        path: 'physical/score',
                        name: 'project:apply:physical:score',
                        props: {
                            title: '体检结果',
                            type: 3
                        },
                        component: () => import('@/views/exam-project/score-page')
                    }
                ]
            }
        ]
    },
    {
        path: '/my',
        component: () => import('@/components/app-main'),
        children: [
            {
                path: '/my',
                name: 'my',
                component: () => import('@/views/my/index'),
                children: [
                    {
                        path: 'apply',
                        name: 'apply',
                        component: () => import('@/views/my/components/apply')
                    },
                    {
                        path: 'center',
                        name: 'user-center',
                        component: () => import('@/views/my/components/user-center')
                    },
                    {
                        path: 'set',
                        name: 'user-set',
                        component: () => import('@/views/my/components/user-set')
                    }
                ]
            }
        ]
    },
    {
        path: '/feedback',
        component: () => import('@/components/app-main'),
        children: [
            {
                path: '/feedback',
                name: 'feedback',
                component: () => import('@/views/my/feedbackList')
            }
        ]
    },
    // 错误页面
    {
        path: '/401',
        name: 'error_401',
        component: () => import('@/views/error-page/401.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        component: () => import('@/views/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        component: () => import('@/views/error-page/404.vue')
    },
    {
        path: '/yanye',
        name: 'yanye',
        component: () => import('@/views/error-page/404.vue')
    },
    {
        path: '/guangde',
        name: 'guangde',
        component: () => import('@/views/error-page/404.vue')
    }
];
